<template>
  <div>
    <div class="row border-bottom border-secondary mb-1">
      <p class="mb-2 font-weight-medium">Total de NFS-e: {{ resumo.total }} | Valor Total de NFS-e:
        {{ resumo.valor_notas | formatNumeroBr }} | Valor Total do ISS: {{ resumo.valor_iss | formatNumeroBr }} </p>
    </div>
    <div v-show="!list_notas || list_notas.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem notas
    </div>
    <div v-for="g in list_notas" :key="g.nip_codigo" class="row">
      <div class="col-md-12 mb-1 border-bottom border-secondary">
        <div class="row mb-1">
          <div class="col-md-4">
            <b-form-group label="Nota Fiscal">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ g.nip_numero || '-' }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Emissão - Competência">
              <h6 class="mb-0">
                <span v-if="!g.nip_emissao"> - </span>
                <span class="text-body font-weight-bold" v-else>{{ g.nip_emissao | formatDateHora }} - </span>
                <span class="text-body font-weight-bold">{{ g.nip_competencia | formatDateCompetencia }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Situação">
              <h6 class="mb-0">
                <span class="badge badge-info font-size-12">Importada do ADN</span>
                <span v-show="g.nip_iss_retido === 'S'" class="ml-1 badge badge-warning font-size-12">ISS Retido</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div v-if="g.nip_cpf_cnpj_prestador" class="col-md-4">
            <b-form-group label="CPF/CNPJ Prestador">
              <h6 class="mb-0">
                <span v-if="g.nip_cpf_cnpj_prestador.length < 12">{{
                    g.nip_cpf_cnpj_prestador | VMask('###.###.###-##')
                  }}</span>
                <span v-else>{{ g.nip_cpf_cnpj_prestador | VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Nome/Razao Social Prestador">
              <h6 class="mb-0">{{ g.nip_razao_social_prestador }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Município de Emissão">
              <h6 class="mb-0">
                <span v-if="g.municipio_emissao_nome">{{ g.municipio_emissao_nome }} - {{
                    g.municipio_emissao_uf
                  }}</span>
                <span v-else>{{ g.nip_municipio_emissao || '-' }}</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div v-if="g.nip_cpf_cnpj_tomador" class="col-md-4">
            <b-form-group label="CPF/CNPJ Tomador">
              <h6 class="mb-0">
                <span v-if="g.nip_cpf_cnpj_tomador.length < 12">{{
                    g.nip_cpf_cnpj_tomador | VMask('###.###.###-##')
                  }}</span>
                <span v-else>{{ g.nip_cpf_cnpj_tomador | VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Nome/Razao Social Tomador">
              <h6 class="mb-0">{{ g.nip_razao_social_tomador }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Município de Incidência">
              <h6 class="mb-0">
                <span v-if="g.municipio_incidencia_nome">{{ g.municipio_incidencia_nome }} - {{
                    g.municipio_incidencia_uf
                  }}</span>
                <span v-else>{{ g.nip_municipio_incidencia || '-' }}</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Valor da Nota">
              <h6 class="mb-0">{{ g.nip_valor | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Valor do ISS">
              <h6 class="mb-0">{{ g.nip_iss | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Tributação">
              <h6 class="mb-0">{{ g.nip_exigibilidade_iss | exigibilidadeIss }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Chave de Acesso">
              <h6 class="mb-0 font-size-12">
                <a :href="url_consulta_publica" target="_blank" rel="noopener"
                   title="Consultar esta nota no portal nacional da NFS-e">
                  {{ chaveAcesso(g.nip_nsu) }}
                </a>
                <button type="button"
                        class="btn btn-link btn-sm p-0 ml-2 align-baseline font-size-12"
                        @click="copiarChave(g)">
                  <i class="bx bx-copy"></i>
                  {{ (chave_copiada === g.nip_codigo) ? 'copiado!' : 'copiar' }}
                </button>
              </h6>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const URL_CONSULTA_PUBLICA = "https://www.nfse.gov.br/consultapublica";

export default {
  props: {
    resumo: {
      type: Object,
      default: () => ({
        total: 0,
        valor_notas: 0,
        valor_iss: 0
      })
    },
    list_notas: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      url_consulta_publica: URL_CONSULTA_PUBLICA,
      chave_copiada: null,
      copia_timeout: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.copia_timeout);
  },
  methods: {
    //O NSU vem do ADN com o prefixo NFS, que nao faz parte da chave de acesso
    chaveAcesso(nsu) {
      if (!nsu) {
        return '-';
      }
      return String(nsu).replace(/^NFS/i, '');
    },
    async copiarChave(nota) {
      try {
        await navigator.clipboard.writeText(this.chaveAcesso(nota.nip_nsu));
        this.chave_copiada = nota.nip_codigo;
        clearTimeout(this.copia_timeout);
        this.copia_timeout = setTimeout(() => {
          this.chave_copiada = null;
        }, 3000);
      } catch (err) {
        console.error('Erro ao copiar:', err);
      }
    },
  },
};
</script>
